import {
  EntityListData,
  FormattedTransaction,
} from "~/types";
import { TransactionTableLoaderResult } from "~/services/apiClient";
import * as APITypes from "~/API";

export function formatTransactionTableRows(
  rawTransactionList: TransactionTableLoaderResult["transactionList"],
): FormattedTransaction[] {
  return rawTransactionList.map((item) => {
    const formatted: FormattedTransaction = {
      id: item.id,
      details: item.details,
      tenantInfo: item.tenantInfo,
    };
    if (item.entityDetails.unit?.data) {
      formatted[APITypes.EntityType.Unit] = item.entityDetails.unit.data;
    }
    if (item.entityDetails.building?.data) {
      formatted[APITypes.EntityType.Building] =
        item.entityDetails.building.data;
    }
    if (item.entityDetails.parcel?.data) {
      formatted[APITypes.EntityType.Parcel] = item.entityDetails.parcel.data;
    }
    return formatted;
  });
}

export function buildUnitListMapFromLoaderResult(
  result: Pick<
    TransactionTableLoaderResult,
    "propertyList" | "buildingList" | "unitList"
  >,
): EntityListData {
  const propertyList = result.propertyList ?? [];
  const buildingList = result.buildingList ?? [];
  const unitListFromLambda = result.unitList ?? [];
  const unitList = unitListFromLambda.map((u) => u.unitDetails);

  const propertyMap: Record<string, APITypes.Property> = {};
  propertyList.forEach((p) => {
    propertyMap[p.id] = p;
  });

  const buildingMap: Record<string, APITypes.Building> = {};
  buildingList.forEach((b) => {
    buildingMap[b.id] = b;
  });
  unitListFromLambda.forEach((u) => {
    if (u.buildingDetails?.id) {
      buildingMap[u.buildingDetails.id] = u.buildingDetails;
    }
  });

  const unitMap: Record<string, APITypes.Unit> = {};
  unitList.forEach((u) => {
    unitMap[u.id] = u;
  });

  return {
    propertyList,
    buildingList,
    unitList,
    serviceRequestList: [],
    amenityList: [],
    propertyMap,
    buildingMap,
    unitMap,
  };
}
